import { IconWrapper, ISvgIconProps } from "@icon-park/svg/lib/runtime";

export default IconWrapper(
  "facebooksquare",
  (props: ISvgIconProps) =>
    `<svg width=${props.size} height=${props.size} viewBox="0 0 48 48" fill="none">` +
    `<path d="M44.5382 0H3.46179C1.5498 0 0 1.5498 0 3.46179V44.5382C0 46.4502 1.5498 48 3.46179 48H25.6406V29.4375H19.4062V22.1719H25.6406V16.8248C25.6406 10.6241 29.4261 7.24915 34.9574 7.24915C37.6066 7.24915 39.8833 7.44653 40.5469 7.53479V14.0156H36.7328C33.7233 14.0156 33.1406 15.4457 33.1406 17.5444V22.1719H40.3359L39.3984 29.4375H33.1406V48H44.5382C46.4502 48 48 46.4502 48 44.5382V3.46179C48 1.5498 46.4502 0 44.5382 0Z" fill="${props.colors[0]}" />` +
    "</svg>"
);
